import { combineReducers } from 'redux'
import merge from 'lodash/merge'
import { RECEIVE_LICENSES, RECEIVE_LICENSE, RECEIVE_LICENSE_GROUP_OPTIONS, RESET_SEARCH_RESULTS } from '../actions/license-actions'

import { RESET_STORE } from '../actions/currentUser-actions'

const searchResults = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_LICENSES:
      return merge([], action.licenses, { query: action.query })
    case RESET_STORE:
      return []
    case RESET_SEARCH_RESULTS:
      return {
           ...state,
           searchResults: [],
      };
    default:
      return state
  }
}

const detail = (state = { groupOptions: [] }, action) => {
  switch (action.type) {
    case RECEIVE_LICENSE:
      return { ...state, license: action.license }
    case RESET_STORE:
      return {}
    case RECEIVE_LICENSE_GROUP_OPTIONS:
      return { ...state, groupOptions: action.groupOptions }
    default:
      return state
  }
}

export default combineReducers({
  searchResults,
  detail,
})
